window.addEventListener('DOMContentLoaded', () => {
    fix100vh();
    window.addEventListener('resize', () => {
        fix100vh();
        getScrollBarSize()
    })

    getScrollBarSize()

    $('input[type="tel"]').mask('+7 (999) 999-99-99', { autoclear: false }, { placeholder: '+7 (   )    -  -  ' });

    let localeRu = {
        days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        daysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
        daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        today: 'Сегодня',
        clear: 'Очистить',
        dateFormat: 'dd.MM.yyyy',
        timeFormat: 'HH:mm',
        firstDay: 1
    };

    let localeEn = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'dd.MM.yyyy',
        timeFormat: 'HH:mm',
        firstDay: 1
    };

    /**
     * https://stackoverflow.com/questions/2945113/how-to-create-a-new-date-in-javascript-from-a-non-standard-date-format
     * @param input
     * @returns {Date}
     */
    function parseDate(input) {
        if(!input){
            return '';
        }
        const parts = input.match(/(\d+)/g);
        return new Date(parts[2], parts[1]-1, parts[0]);
    }

    let dateInputs = document.querySelectorAll('.date-input input')
    dateInputs.forEach(el => {
        let locale = el.getAttribute('data-locale') || 'ru';
        new AirDatepicker(el, {
            locale: locale === 'ru' ? localeRu : localeEn,
            autoClose: true,
            toggleSelected: false,
            minDate: '',
            maxDate: parseDate(el.getAttribute('data-max-date')),
            selectedDates: [parseDate(el.value)],
            onSelect: () => {

            }
        })
    })
})

function fix100vh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

$(".quiz-card2 input").change(function () {
    let checkedCount = $(".quiz-card2 input:checked").length
    let btn = $(this).parents(".quiz").find(".quiz-content__btn")

    if(checkedCount>0){
        $(btn).prop("disabled",false)
    }else{
        $(btn).prop("disabled",true)
    }
})

$(".quiz-card input").change(function () {
    let checkedCount = $(".quiz-card input:checked").length
    let btn = $(this).parents(".quiz").find(".quiz-content__btn")

    if(checkedCount>0){
        $(btn).prop("disabled",false)
    }else{
        $(btn).prop("disabled",true)
    }
})

$(".channel-card2").click(function () {
    let videoSrc = $(this).attr("data-video")

    let video = document.querySelector(".recommendation__video video")
    video.setAttribute("src",videoSrc)
    video.addEventListener('click',function(){
        video.play();
    },false);
    video.click();

    console.log(video)
})

$(".file-input input").change(function (e) {
    let parent = $(this).parents(".file-input")
    const [file] = e.target.files
    let fileName = file.name
    $(parent).find(".file-input__output span").html(fileName)
})

$(".qa-card__show").click(function () {
    let parent = $(this).parents(".qa-card")

    if($(parent).hasClass("_open")){
        $(".qa-card").removeClass("_open")
        $(".qa-card__hidden").slideUp()
    } else{
        $(".qa-card").removeClass("_open")
        $(".qa-card__hidden").slideUp()
        $(parent).addClass("_open")
        $(parent).find(".qa-card__hidden").slideDown()
    }
})

